import React, { ReactNode } from 'react';
import './Tag.scss';

export type TagColor =
  | 'green' | 'blue' | 'orange' | 'plum' | 'red' | 'grey'
  | 'white' | 'yellow' | 'purple' | 'teal' | 'lime' | 'warning';

type Props = {
  label: string;
  color?: TagColor;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
};

const Tag: React.FC<Props> = ({ label, color = 'grey', startIcon, endIcon }) => (
  <div className={`ds-tag ds-tag--${color}`}>
    {startIcon && <span className="ds-tag__icon ds-tag__icon--start">{startIcon}</span>}
    <span className="ds-tag__label">{label}</span>
    {endIcon && <span className="ds-tag__icon ds-tag__icon--end">{endIcon}</span>}
  </div>
);

export default Tag;
